import { render, staticRenderFns } from "./vIconWithTooltip.vue?vue&type=template&id=5b8998c0"
import script from "./vIconWithTooltip.vue?vue&type=script&setup=true&lang=ts"
export * from "./vIconWithTooltip.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./vIconWithTooltip.vue?vue&type=style&index=0&id=5b8998c0&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports